export default {
  badge: 'Ženklelis',
  open: 'Atidaryti',
  close: 'Uždaryti',
  dismiss: 'Atmesti',
  confirmEdit: {
    ok: 'Gerai',
    cancel: 'Atšaukti',
  },
  dataIterator: {
    noResultsText: 'Nerasta atitinkančių įrašų',
    loadingText: 'Kraunama...',
  },
  dataTable: {
    itemsPerPageText: 'Eilutės per puslapį:',
    ariaLabel: {
      sortDescending: 'Išrikiuota mažėjimo tvarka.',
      sortAscending: 'Išrikiuota didėjimo tvarka.',
      sortNone: 'Nerikiuota.',
      activateNone: 'Suaktyvinkite, jei norite rikiavimą pašalinti.',
      activateDescending: 'Suaktyvinkite, jei norite rikiuoti mažėjimo tvarka.',
      activateAscending: 'Suaktyvinkite, jei norite rikiuoti didėjimo tvarka.',
    },
    sortBy: 'Rikiuoti pagal',
  },
  dataFooter: {
    itemsPerPageText: 'Įrašai per puslapį:',
    itemsPerPageAll: 'Visi',
    nextPage: 'Kitas puslapis',
    prevPage: 'Ankstesnis puslapis',
    firstPage: 'Pirmas puslapis',
    lastPage: 'Paskutinis puslapis',
    pageText: '{0}-{1} iš {2}',
  },
  dateRangeInput: {
    divider: 'iki',
  },
  datePicker: {
    itemsSelected: '{0} parinkta',
    range: {
      title: 'Pasirinkite datas',
      header: 'Įveskite datas',
    },
    title: 'Pasirinkite datą',
    header: 'Įveskite datą',
    input: {
      placeholder: 'Įveskite datą',
    },
    ariaLabel: {
      previousMonth: 'Ankstesnis mėnuo',
      nextMonth: 'Kitas mėnuo',
      selectYear: 'Pasirinkite metus',
      previousYear: 'Praėję metai',
      nextYear: 'Kiti metai',
      selectMonth: 'Pasirinkite mėnesį',
      selectDate: '{0}',
      currentDate: 'Šiandien, {0}',
    },
  },
  noDataText: 'Nėra duomenų',
  carousel: {
    prev: 'Ankstesnioji skaidrė',
    next: 'Kita skaidrė',
    ariaLabel: {
      delimiter: 'Skaidrė {0} iš {1}',
    },
  },
  calendar: {
    moreEvents: 'Daugiau {0}',
    today: 'Šiandien',
  },
  input: {
    clear: 'Išvalyti {0}',
    prependAction: '{0} pridėtas veiksmas',
    appendAction: '{0} pridėtas veiksmas',
    otp: 'Prašome įvesti OTP simbolį {0}',
  },
  fileInput: {
    counter: '{0} failų',
    counterSize: '{0} failų ({1} iš viso)',
  },
  fileUpload: {
    title: 'Vilkite ir numeskite failus čia',
    divider: 'arba',
    browse: 'Naršyti failus',
  },
  timePicker: {
    am: 'AM',
    pm: 'PM',
    title: 'Pasirinkite laiką',
    hour: 'Valanda',
    minute: 'Minutės',
    second: 'Sekundės',
  },
  pagination: {
    ariaLabel: {
      root: 'Puslapio naršymas',
      next: 'Kitas puslapis',
      previous: 'Ankstesnis puslapis',
      page: 'Eiti į puslapį {0}',
      currentPage: 'Dabartinis puslapis, puslapis {0}',
      first: 'Pirmas puslapis',
      last: 'Paskutinis puslapis',
    },
  },
  stepper: {
    next: 'Kitas',
    prev: 'Ankstesnis',
  },
  rating: {
    ariaLabel: {
      item: 'Įvertinimas {0} iš {1}',
    },
  },
  loading: 'Kraunama...',
  infiniteScroll: {
    loadMore: 'Užkrauti daugiau',
    empty: 'Daugiau nėra',
  },
  rules: {
    required: 'Šis laukas yra privalomas',
    email: 'Prašome įvesti galiojantį el. pašto adresą',
    number: 'Šiame lauke gali būti tik skaičiai',
    integer: 'Šiame lauke gali būti tik sveiki skaičiai',
    capital: 'Šiame lauke gali būti tik didžiosios raidės',
    maxLength: 'Turite įvesti ne daugiau kaip {0} simbolių',
    minLength: 'Turite įvesti bent {0} simbolius',
    strictLength: 'Įvesto lauko ilgis yra neteisingas',
    exclude: 'Simbolis {0} nėra leidžiamas',
    notEmpty: 'Prašome pasirinkti bent vieną reikšmę',
    pattern: 'Neteisingas formatas',
  },
  hotkey: {
    then: 'tada',
    ctrl: 'Ctrl',
    command: 'Command',
    shift: 'Shift',
    alt: 'Alt',
    option: 'Option',
    enter: 'Enter',
    escape: 'Escape',
    upArrow: 'Rodyklė į viršų',
    downArrow: 'Rodyklė žemyn',
    leftArrow: 'Rodyklė kairėn',
    rightArrow: 'Rodyklė dešinėn',
    backspace: 'Backspace',
    space: 'Tarpas',
    plus: 'plius',
    shortcut: 'Klaviatūros trumpinys: {0}',
    or: 'arba',
  },
  video: {
    play: 'Groti',
    pause: 'Pauzė',
    seek: 'Ieškoti',
    volume: 'Garsumas',
    showVolume: 'Rodyti garso valdymą',
    mute: 'Nutildyti',
    unmute: 'Įjungti garsą',
    enterFullscreen: 'Visas ekranas',
    exitFullscreen: 'Išeiti iš viso ekrano',
  },
  colorPicker: {
    ariaLabel: {
      eyedropper: 'Pasirinkite spalvą iš ekrano',
      hueSlider: 'Atspalvis',
      alphaSlider: 'Skaidrumas',
      redInput: 'Raudona',
      greenInput: 'Žalia',
      blueInput: 'Mėlyna',
      alphaInput: 'Skaidrumas',
      hueInput: 'Atspalvis',
      saturationInput: 'Sodrumas',
      lightnessInput: 'Šviesumas',
      hexInput: 'HEX reikšmė',
      hexaInput: 'HEX su skaidrumo reikšme',
      changeFormat: 'Keisti spalvos formatą',
    },
  },
}
